import React from 'react'

const ServiceNowChannelSelection = ({
  filteredChannel,
  selectedChannel,
  handleChannelSelection
}) => {
  return (
    <div className='space-y-2'>
      {filteredChannel.map((item) => {
        const isSelected = selectedChannel?.Spec?.Id === item.Spec.Id

        return (
          <button
            key={item.ObjectMeta.id}
            type='button'
            onClick={() => handleChannelSelection(item)}
            className={`flex w-full items-center justify-between rounded-xs border px-3 py-2 text-left transition
              ${
                isSelected
                  ? 'border-[var(--color-primary-light)] bg-[var(--color-blue-100)]'
                  : 'border-[var(--color-primary-light)] bg-white hover:bg-gray-50'
              }
            `}
          >
            <span className='text-sm'>{item.Spec.Name}</span>

            {/* Tick / Untick Circle */}
            <div
              className={`
                h-6 w-6 rounded-full flex items-center justify-center border transition-all duration-200
                ${isSelected ? 'bg-blue-600 border-blue-600' : 'border-gray-400 bg-white'}
              `}
            >
              {isSelected && (
                <div className='w-2 h-3 border-r-2 border-b-2 mb-1 border-white rotate-45'></div>
              )}
            </div>
          </button>
        )
      })}
    </div>
  )
}

export { ServiceNowChannelSelection }
